export default __webpack_public_path__ + "static/media/twitter.703dd7fd.svg";